import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../Lightcast.scss";
import translate from "src/i18n/translate";
import { useIntl } from "react-intl";
import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import WidgetLoader from "src/features/common/elements/WidgetLoader";
import ApiError from "../../common/elements/ApiError";
export default function BottomGrowingIndustries(_a) {
    var industries = _a.industries, loader = _a.loader, forHtml = _a.forHtml;
    function useGetPopoverTextLabel(changeVal) {
        return useIntl().formatMessage({
            id: "app.bottomGrowingOccp.popoverTextLabel"
        }, {
            changeJob: changeVal.toLocaleString()
        });
    }
    var GetPopoverTextLabel = function (changeVal) {
        return useGetPopoverTextLabel(changeVal);
    };
    var chartLabel = useIntl().formatMessage({
        id: "app.bottomGrowingInd.bottomThreeGrowing"
    });
    return (_jsxs("div", { className: forHtml ? "bottom-growing-industries" : "paper-card", children: [_jsx("div", { className: "header", children: _jsxs("div", { className: "info", children: [_jsx("h3", { className: forHtml ? "html-title" : "title", children: translate("app.bottomGrowingInd.bottomThreeGrowing") }), _jsx("p", { className: forHtml ? "html-desc" : "description -des", children: translate("app.bottomGrowingInd.reviewBottomIndus") })] }) }), _jsxs("div", { className: "body", children: [industries && _jsx(IndustriesChart, { industries: industries }), loader && !industries && (_jsx(WidgetLoader, { loaderContainerClasses: "loader", loaderClasses: "content" })), !loader && !industries && _jsx(ApiError, {})] })] }));
}
function useGetPopoverTextLabel(changeVal) {
    return useIntl().formatMessage({
        id: "app.bottomGrowingOccp.popoverTextLabel"
    }, {
        changeJob: changeVal.toLocaleString()
    });
}
var GetPopoverTextLabel = function (changeVal) {
    return useGetPopoverTextLabel(changeVal);
};
var IndustriesChart = function (_a) {
    var industries = _a.industries;
    var chartLabel = useIntl().formatMessage({
        id: "app.bottomGrowingInd.bottomThreeGrowing"
    });
    return (_jsx(WmChart, { label: chartLabel, labelPosition: "none", chartType: "bar6", valueFormat: "amount", showGrid: true, labelWidth: "120px", "print-mode": true, children: industries.map(function (row) {
            return (_jsx(WmChartSlice, { amount: String(row === null || row === void 0 ? void 0 : row.change), legend: row === null || row === void 0 ? void 0 : row.name, popoverText: GetPopoverTextLabel(String(row === null || row === void 0 ? void 0 : row.change)), popoverTitle: row === null || row === void 0 ? void 0 : row.changePercentage }, row === null || row === void 0 ? void 0 : row.name));
        }) }));
};
